type ContactParamValue = string | number | null | undefined;

export const buildContactPath = (params?: Record<string, ContactParamValue>) => {
  if (!params) {
    return "/contact";
  }

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    const normalized = String(value).trim();
    if (!normalized) return;
    searchParams.set(key, normalized);
  });

  const query = searchParams.toString();
  return query ? `/contact?${query}` : "/contact";
};

export const formatContactParam = (value: string) =>
  value
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (character) => character.toUpperCase());
